// Module
var code = "<div class=\"time-range-result\" ir-range-result intervals=\"$ctrl.mappedRanges\" interval-height=\"$ctrl.intervalHeight\" interval-length=\"$ctrl.intervalLength\" intervals-count=\"$ctrl.intervalsCount\" low-resolution-mode=\"$ctrl.lowResolutionMode\" tooltip-mapper=\"$ctrl.tooltipMapper\"></div> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/Forms/TimeRangeResult/TimeRangeResult.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;